import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { resetFilters, saveContactOrders } from 'features/views/campaignDashboards/order/actions';

export const ActionButtons = ({ campaign, orderActive }) => {
	const dispatch = useDispatch();

	const handleSubmit = useCallback(() => {
		dispatch(saveContactOrders(campaign?.id));
	}, [dispatch, campaign?.id]);

	const handleReset = useCallback(() => {
		dispatch(resetFilters());
	}, [dispatch]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid size={8} />
					<Grid size={2}>
						<Button variant="outlined" onClick={handleReset} fullWidth>
							{getLabelMessage('common:resetButton')}
						</Button>
					</Grid>
					<Grid size={2}>
						<ComponentLoader fetchStorePath={`${fetch.constants.urls.campaignOrder}.put`} ignoreErrors>
							<Button variant="contained" onClick={handleSubmit} disabled={!orderActive} fullWidth>
								{getLabelMessage('common:save')}
							</Button>
						</ComponentLoader>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

ActionButtons.propTypes = {
	campaign: PropTypes.object,
	orderActive: PropTypes.bool,
};

export default ActionButtons;
